// extracted by mini-css-extract-plugin
module.exports = {"header":"pages-sponsorships-sendEmail__header--3WNJ9"};